var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BCarouselSlide',{scopedSlots:_vm._u([{key:"img",fn:function(){return [_c('b-row',{staticClass:"mt-4 mb-4 ml-4 h-100 justify-content-center"},_vm._l((_vm.slideContent),function(card,index){return _c('CarouselCard',{key:index,staticClass:"col-lg-5 col-md-6 col-sm-6",attrs:{"card":card}})}),1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }